/**
* This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { CosmWasmClient, SigningCosmWasmClient, ExecuteResult } from "@cosmjs/cosmwasm-stargate";
import { Coin, StdFee } from "@cosmjs/amino";
import { Uint128, InstantiateMsg, ExecuteMsg, ProposalStatus, Outcome, Proposal, Tally, QueryMsg, MarketStatus, ClaimResponse, MarketResponse, Uint256, PoolsResponse, OutcomeAccum, PositionResponse, MarketsResponse } from "./Madvotes.types";
export interface MadvotesReadOnlyInterface {
  contractAddress: string;
  getProposal: ({
    proposalId
  }: {
    proposalId: number;
  }) => Promise<Proposal>;
  getMarket: ({
    proposalId
  }: {
    proposalId: number;
  }) => Promise<MarketResponse>;
  getPosition: ({
    depositor,
    proposalId
  }: {
    depositor: string;
    proposalId: number;
  }) => Promise<PositionResponse>;
  getPools: ({
    proposalId
  }: {
    proposalId: number;
  }) => Promise<PoolsResponse>;
  getClaim: ({
    depositor,
    proposalId
  }: {
    depositor: string;
    proposalId: number;
  }) => Promise<ClaimResponse>;
  listMarkets: ({
    limit,
    startAfter,
    status
  }: {
    limit?: number;
    startAfter?: number;
    status?: MarketStatus;
  }) => Promise<MarketsResponse>;
}
export class MadvotesQueryClient implements MadvotesReadOnlyInterface {
  client: CosmWasmClient;
  contractAddress: string;
  constructor(client: CosmWasmClient, contractAddress: string) {
    this.client = client;
    this.contractAddress = contractAddress;
    this.getProposal = this.getProposal.bind(this);
    this.getMarket = this.getMarket.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.getPools = this.getPools.bind(this);
    this.getClaim = this.getClaim.bind(this);
    this.listMarkets = this.listMarkets.bind(this);
  }
  getProposal = async ({
    proposalId
  }: {
    proposalId: number;
  }): Promise<Proposal> => {
    return this.client.queryContractSmart(this.contractAddress, {
      get_proposal: {
        proposal_id: proposalId
      }
    });
  };
  getMarket = async ({
    proposalId
  }: {
    proposalId: number;
  }): Promise<MarketResponse> => {
    return this.client.queryContractSmart(this.contractAddress, {
      get_market: {
        proposal_id: proposalId
      }
    });
  };
  getPosition = async ({
    depositor,
    proposalId
  }: {
    depositor: string;
    proposalId: number;
  }): Promise<PositionResponse> => {
    return this.client.queryContractSmart(this.contractAddress, {
      get_position: {
        depositor,
        proposal_id: proposalId
      }
    });
  };
  getPools = async ({
    proposalId
  }: {
    proposalId: number;
  }): Promise<PoolsResponse> => {
    return this.client.queryContractSmart(this.contractAddress, {
      get_pools: {
        proposal_id: proposalId
      }
    });
  };
  getClaim = async ({
    depositor,
    proposalId
  }: {
    depositor: string;
    proposalId: number;
  }): Promise<ClaimResponse> => {
    return this.client.queryContractSmart(this.contractAddress, {
      get_claim: {
        depositor,
        proposal_id: proposalId
      }
    });
  };
  listMarkets = async ({
    limit,
    startAfter,
    status
  }: {
    limit?: number;
    startAfter?: number;
    status?: MarketStatus;
  }): Promise<MarketsResponse> => {
    return this.client.queryContractSmart(this.contractAddress, {
      list_markets: {
        limit,
        start_after: startAfter,
        status
      }
    });
  };
}
export interface MadvotesInterface extends MadvotesReadOnlyInterface {
  contractAddress: string;
  sender: string;
  registerMarket: ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, fee_?: number | StdFee | "auto", memo_?: string, funds_?: Coin[]) => Promise<ExecuteResult>;
  placeBet: ({
    outcome,
    proposalId
  }: {
    outcome: Outcome;
    proposalId: number;
  }, fee_?: number | StdFee | "auto", memo_?: string, funds_?: Coin[]) => Promise<ExecuteResult>;
  settleMarket: ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, fee_?: number | StdFee | "auto", memo_?: string, funds_?: Coin[]) => Promise<ExecuteResult>;
  claim: ({
    proposalId
  }: {
    proposalId: number;
  }, fee_?: number | StdFee | "auto", memo_?: string, funds_?: Coin[]) => Promise<ExecuteResult>;
}
export class MadvotesClient extends MadvotesQueryClient implements MadvotesInterface {
  client: SigningCosmWasmClient;
  sender: string;
  contractAddress: string;
  constructor(client: SigningCosmWasmClient, sender: string, contractAddress: string) {
    super(client, contractAddress);
    this.client = client;
    this.sender = sender;
    this.contractAddress = contractAddress;
    this.registerMarket = this.registerMarket.bind(this);
    this.placeBet = this.placeBet.bind(this);
    this.settleMarket = this.settleMarket.bind(this);
    this.claim = this.claim.bind(this);
  }
  registerMarket = async ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, fee_: number | StdFee | "auto" = "auto", memo_?: string, funds_?: Coin[]): Promise<ExecuteResult> => {
    return await this.client.execute(this.sender, this.contractAddress, {
      register_market: {
        proposal,
        proposal_id: proposalId
      }
    }, fee_, memo_, funds_);
  };
  placeBet = async ({
    outcome,
    proposalId
  }: {
    outcome: Outcome;
    proposalId: number;
  }, fee_: number | StdFee | "auto" = "auto", memo_?: string, funds_?: Coin[]): Promise<ExecuteResult> => {
    return await this.client.execute(this.sender, this.contractAddress, {
      place_bet: {
        outcome,
        proposal_id: proposalId
      }
    }, fee_, memo_, funds_);
  };
  settleMarket = async ({
    proposal,
    proposalId
  }: {
    proposal: Proposal;
    proposalId: number;
  }, fee_: number | StdFee | "auto" = "auto", memo_?: string, funds_?: Coin[]): Promise<ExecuteResult> => {
    return await this.client.execute(this.sender, this.contractAddress, {
      settle_market: {
        proposal,
        proposal_id: proposalId
      }
    }, fee_, memo_, funds_);
  };
  claim = async ({
    proposalId
  }: {
    proposalId: number;
  }, fee_: number | StdFee | "auto" = "auto", memo_?: string, funds_?: Coin[]): Promise<ExecuteResult> => {
    return await this.client.execute(this.sender, this.contractAddress, {
      claim: {
        proposal_id: proposalId
      }
    }, fee_, memo_, funds_);
  };
}